import { render, staticRenderFns } from "./MakingSpace.vue?vue&type=template&id=3ccedf6f&scoped=true&"
import script from "./MakingSpace.vue?vue&type=script&lang=js&"
export * from "./MakingSpace.vue?vue&type=script&lang=js&"
import style0 from "./MakingSpace.vue?vue&type=style&index=0&id=3ccedf6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccedf6f",
  null
  
)

export default component.exports